import React from "react";
import "./ProjectPage.css";
import "../app/PageBackground.css";
import { getTagStyle } from "../utils/tagColors";
import { ItchIcon, SteamIcon, DiscordIcon, GlobeIcon } from "./icons";
import PillButton from "./PillButton";

function getLinkLabelFromHref(href, fallback) {
  if (!href) return fallback || "Website";
  const url = href.toLowerCase();
  if (url.includes("discord.gg")) return "Discord";
  if (url.includes("steampowered.com")) return "Steam";
  if (url.includes("itch.io")) return "itch.io";
  return fallback || "Website";
}

export default function ProjectPage({
  name,
  image,
  description,
  buzzwords = [],
  contribution,
  imageRight = false,
  tags = [],
  links = [],
  bgImage,
  companyName,
  children,
}) {
  return (
    <section
      className="PageBackground"
      style={{
        "--page-bg-image": bgImage ? `url(${bgImage})` : undefined,
        "--page-bg-blur": "4px",
      }}
    >
      <div className={`ProjectPage ${imageRight ? "ProjectPage--imageRight" : ""} PageBackground__content`}>
        <div className="ProjectPage__container">
        <div className="ProjectPage__hero">
          <div className="ProjectPage__media">
            {links && links.length > 0 ? (
              <a
                href={links[0].href}
                target={links[0].external ? "_blank" : undefined}
                rel={links[0].external ? "noreferrer" : undefined}
                className="ProjectPage__thumbLink"
                aria-label={`${name} - ${links[0].label}`}
              >
                <img className="ProjectPage__thumb" src={image} alt={name} />
              </a>
            ) : (
              <img className="ProjectPage__thumb" src={image} alt={name} />
            )}
            {companyName && (
              <p className="ProjectPage__disclaimer">
                *Images and logos are property of {companyName}. No ownership or endorsement is claimed.
              </p>
            )}
          </div>
          <div className="ProjectPage__right">
            <h1 className="ProjectPage__titleRight">{name}</h1>
            {(tags && tags.length > 0) || (links && links.length > 0) ? (
              <div className="ProjectPage__meta">
                {tags && tags.length > 0 && (
                  <ul className="ProjectPage__thumbTags" aria-label="Project tags">
                    {tags.map((t, i) => (
                      <li className="ProjectPage__badge" key={i} style={getTagStyle(t)}>{t}</li>
                    ))}
                  </ul>
                )}
                {links && links.length > 0 && (
                  <div className="ProjectPage__thumbLinks" aria-label="Project links">
                    {links.map((link, i) => {
                      const computedLabel = getLinkLabelFromHref(link.href, link.label);
                      const icon = link.href.includes("itch.io") ? <ItchIcon width={24} height={24} />
                        : link.href.includes("steampowered.com") ? <SteamIcon width={24} height={24} />
                        : link.href.includes("discord.gg") ? <DiscordIcon width={24} height={24} />
                        : <GlobeIcon width={24} height={24} />;
                      return (
                        <PillButton
                          key={i}
                          href={link.href}
                          external={!!link.external}
                          label={computedLabel}
                          icon={icon}
                          className="ProjectPage__pillLink"
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            ) : null}
            <div className="ProjectPage__desc">
              {typeof description === "string" ? <p>{description}</p> : description}
            </div>
          </div>
        </div>

        {/* Buzzwords section - full width below hero */}
        {buzzwords && buzzwords.length > 0 && (
          <section className="ProjectPage__buzzwordsSection">
            <ul className="ProjectPage__buzzwords" aria-label="Technologies and buzzwords">
              {buzzwords.map((word, i) => (
                <li className="ProjectPage__buzzword" key={i} style={getTagStyle(word)}>{word}</li>
              ))}
            </ul>
          </section>
        )}

        {contribution && (
          <div className="ProjectPage__contribution">
            <h2>My Contribution</h2>
            <div className="ProjectPage__contributionContent">
              {Array.isArray(contribution) ? (
                <>{contribution.map((para, idx) => <p key={idx}>{para}</p>)}</>
              ) : typeof contribution === "string" ? (
                <p>{contribution}</p>
              ) : (
                contribution
              )}
            </div>
          </div>
        )}

        {children && (
          <div className="ProjectPage__extra" style={{ marginTop: "2.5rem" }}>
            {children}
          </div>
        )}
        </div>
      </div>
    </section>
  );
}
